<template>
  <div class="card-view">
    <h2>Preview Invoice</h2>
    <v-card class="card-modal-view" elevation="1" v-if="Object.keys(previewDetails).length > 0">
      <div class="card-header">
        <!-- <h2>{{ previewDetails.invoiceNo }}</h2> -->
        <div class="button-row">
          <!-- <button class="error-btn">Error Trips</button> -->
            <!-- :disabled="checkDisabled()" -->
          <button class="generate-btn" @click="generateInvocie">Generate Invoice</button>
        </div>
      </div>
      <div class="description-grid">
        <strong>*Note:</strong>
        <span>Non verified trips are not included</span>
      </div>

      <div class="basic-preview">
        <div class="preview-header">
          <h5>Invoice Date</h5>
          <span>{{ convertDate(previewDetails.invoiceDate) }}</span>
        </div>
        <div class="preview-header">
          <h5>Invoice Period</h5>
          <span>{{ convertDate(previewDetails.startDate) }} - {{ convertDate(previewDetails.endDate) }}</span>
        </div>
        <div class="preview-header">
          <h5>GST Number</h5>
          <span>{{ previewDetails.receiver.gstNo }}</span>
        </div>
        <div class="preview-header">
          <h5>Number of Trips</h5>
          <span @click="openTripList" class="link-text">{{ previewDetails.calculation.totalTrips }} Trips</span>
        </div>
        <div class="preview-header" v-for="(slab, slabIndex) in previewDetails.calculation.amountBySlab" :key="slabIndex">
          <h5>{{ slab.range }} Slab</h5>
          <span>{{ slab.count }} Trips</span>
        </div>
        <div></div>
      </div>

      <div class="summary-grid">
        <div class="label bg-red">Description</div>
        <div class="value bg-red">Amount/Percentage</div>

        <!-- <div class="label">GST Percentage</div>
        <div class="value">{{ previewDetails.calculation.percentage }}%</div> -->

        <div class="label">{{ previewDetails.calculation.isIGST ? "IGST" : "CGST" }}</div>
        <div class="value">{{ previewDetails.calculation.isIGST ? previewDetails.calculation.igst : previewDetails.calculation.cgst }}%</div>

        <div class="label" v-if="!previewDetails.calculation.isIGST">SGST</div>
        <div class="value" v-if="!previewDetails.calculation.isIGST">{{ previewDetails.calculation.sgst }}%</div>

        <div class="label">Sub Total</div>
        <div class="value">{{ previewDetails.calculation.subtotal }}</div>

        <div class="label">GST Amount</div>
        <div class="value">{{ calculateGstAmount(previewDetails.calculation) }}</div>

        <div class="label">Total</div>
        <div class="value">{{ previewDetails.calculation.total }}</div>
      </div>

      <!-- <div class="preview-details">
        <div class="details-header">
          <span>sample</span>
          <span>Amount</span>
        </div>
      </div> -->
    </v-card>

    <div class="no-data-preview" v-else>
      <span>No data found</span>
    </div>
    <v-dialog v-model="tripViewDialog" width="500" persistent v-if="tripViewDialog">
      <v-card class="dialog-card">
        <h3>View Trips</h3>
        <div @click="tripViewDialog = false" style="position: absolute; right: 20px; cursor: pointer; z-index: 2; top: 10px">
          <svg
            style="height: 30px; width: 30px"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-square-x"
          >
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
            <path d="m15 9-6 6" />
            <path d="m9 9 6 6" />
          </svg>
        </div>
        <div class="trip-list-view">
          <div
            class="trip-item"
            v-for="(trip, tripIndex) in previewDetails.calculation.tripIds"
            :key="tripIndex"
            @click="showTripDetails(trip)"
            :class="{
              'b-right': (tripIndex + 1) % 4 === 0,
              'b-bottom': tripIndex >= previewDetails.calculation.tripIds.length - (previewDetails.calculation.tripIds.length % 4 || 4) || previewDetails.calculation.tripIds.length <= 4,
            }"
          >
            <span>{{ trip.id ? trip.id : trip.tripId }}</span>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="tripDetailsDialog" width="1200">
      <v-card>
        <TripDetails :tripId="tripId" @closeTripDetails="closeTripDetails" v-if="tripDetailsDialog"></TripDetails>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import TripDetails from "@/components/Trips/trip-details/TripDetails";
export default {
  name: "InvocePreview",
  components: { TripDetails },
  props: {
    previewDetails: Object,
  },
  data() {
    return {
      tripViewDialog: false,
      tripDetailsDialog: false,

      tripId: 0,
      
    };
  },
  methods: {
    convertDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    calculateGstAmount(calculation) {
      return calculation.cgstAmount + calculation.igstAmount + calculation.sgstAmount;
    },
    generateInvocie() {
      this.$emit("generateInvoice");
    },
    openTripList() {
      this.tripViewDialog = true;
    },
    closeDialog() {},
    showTripDetails(trip) {
      this.tripDetailsDialog = true;
      this.tripId = trip.tripId;
    },
    closeTripDetails() {
      this.tripDetailsDialog = false;
    },
    checkDisabled() {
      const today = moment(); // current date and time
      const start = moment().startOf("month").date(5); // 5th of this month, 00:00
      const end = moment().startOf("month").date(15).endOf("day"); // 15th, 23:59:59

      const isBetween = today.isBetween(start, end, null, "[]"); // '[]' means inclusive
      return !isBetween;
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  // font-weight: bold;
  border-bottom: 1px solid #d5d5d5;
  padding-bottom: 10px;
}
.card-modal-view {
  padding: 15px;
  margin: 15px;
  border-radius: 10px;

  .card-header {
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #ebebeb;
    align-items: flex-end;
  }
  h2 {
    text-align: start;
    border-bottom: 0;
    text-transform: uppercase;
  }
  .basic-preview {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 0;
    row-gap: 15px;
    .preview-header {
      display: flex;
      flex-direction: column;
      width: 33%;
      h5 {
        color: rgb(149, 149, 149);
        font-size: 12px;
        margin-bottom: 2px;
      }
      span {
        font-weight: bold;
        font-size: 14px;
      }
      .link-text {
        color: rgb(6, 60, 169);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 850px;
    margin: 0 auto;
    // gap: 12px 24px;
    padding: 10px;
    border: 1px solid #e4e4e4;
    font-family: sans-serif;
    background: #fff;
    border-radius: 5px;
  }

  .label {
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #ebebeb;
    padding: 10px;
  }

  .value {
    text-align: right;
    padding: 10px;
    border-bottom: 1px solid #ebebeb;
  }

  .bg-red {
    background: #fff6f1;
    // padding: 9px;
  }

  .preview-details {
    width: 100%;
    margin-top: 15px;
    .details-header {
      background: #fff1f1;
      padding: 8px;
      font-size: 12px;
      display: flex;
      span {
        flex: 1;
      }
    }
  }

  .description-grid {
    display: flex;
    border-bottom: 1px solid #ebebeb;
    padding: 15px 0;
    border-radius: 0;
    strong {
      margin-right: 10px;
    }
  }

  .button-row {
    // max-width: 850px;
    // margin: 20px auto 0;
    display: flex;
    justify-content: center;
    gap: 16px;
    padding-bottom: 8px;
  }

  .error-btn {
    background-color: #e57373;
    color: #fff;
    padding: 10px 24px;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .generate-btn {
    background-color: #f39c12;
    color: #fff;
    padding: 10px 24px;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-transform: uppercase;
    display: flex;
    align-items: center;

    &:disabled {
      background: #d7d7d7;
      color: grey;
    }
  }
}

.dialog-card {
  padding: 15px;

  h3 {
    font-weight: bold;
    padding-bottom: 5px;
    border-bottom: 1px solid #d5d5d5;
    border-radius: 0;
  }
  .trip-list-view {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #e4e4e4;
    margin: 10px 0;
    .trip-item {
      border-right: 1px solid #e4e4e4;
      border-bottom: 1px solid #e4e4e4;
      padding: 8px 10px;
      font-size: 13px;
      width: 25%;
      text-align: center;
      span {
        font-weight: bold;
        cursor: pointer;
        color: #5e7fc3bd;
      }
    }
    .b-right {
      border-right: none;
    }
    .b-bottom {
      border-bottom: none;
    }
  }
}

.no-data-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 310px;
}
</style>
